import {useContext, useEffect, useState} from "react";
import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {getProducts} from "../../api/catalog";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "../../GlobalReducer";
import {ApiRequestInterface} from "../../interfaces/catalog/ApiRequestInterface";
import CatelogBase from "./CatalogBase";

export default function CatalogByParams({params, header, baseUrl} : {params: ApiRequestInterface, header: string, baseUrl: string}) {

    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const {data: response, status} = useQuery({
        queryKey: [params, state.customer?.id],
        queryFn: () => getProducts(params, state.customer),
        //@ts-ignore
        retry: !window.NOSCRIPT ? false : 1,
        enabled: !!params,
    })

    useEffect(() => {
        switch (status) {
            case 'pending':
                dispatch({type: ReducerActionType.LOAD})
                return;
            case 'error':
                dispatch({type: ReducerActionType.ERROR, payload: 'При загрузке товаров возникли ошибки'})
                return;
            case 'success':
                dispatch({type: ReducerActionType.SUCCESS})
                return;
        }
    }, [status]);

    useEffect(() => {
        dispatch({type: ReducerActionType.SET_BREADCRUMBS, payload: [{name: header}]})
    }, [response]);

    return (<>{response && <CatelogBase response={response} header={header} baseUrl={baseUrl} />}</>);
}